import React from "react"
import BottomBar from "../BottomBar/bottombar"
import { useHistory } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { apiEndPoints } from "constants/apiEndpoints"
import { useState, useEffect } from "react"
import axios from "axios"
import "./KioskTrailerType.css"
import { useTranslation } from "react-i18next"

function KioskTrailerType() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [eventData, setEventData]: any = useState()
  const [radioBtnVal, setRadioBtnVal] = useState("")
  const [disabledProceedET, setDisabledProceedET] = useState(true)

  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const facilityId = useSelector(
    (state: RootState) => state.facilityReducer.facility?.id || ""
  )

  const setKioskTrailerType = () => {
    let asset = {
      ...assetReducer.asset,
      equipmentType: radioBtnVal
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    if (!assetReducer?.asset?.fromSummaryPage) {
      history.push("/RFID-code")
    } else {
      history.push("/asset-summary?mode=kiosk")
    }
  }

  useEffect(() => {
    axios
      .get(`${apiEndPoints.facilities}/${facilityId}/fields?action=check-in`)
      .then(response => {
        setEventData(response.data)
      })
  }, [])

  const onRadioBtnChange = (e: any) => {
    setRadioBtnVal(e.target.value)
    if (e.target.checked) {
      setDisabledProceedET(false)
    }
  }
  return (
    <>
      <div className="asset-summary-wrapper container">
        <div className="trailer-type-header">
          {eventData?.data?.checkIn[0].title}
        </div>
        <form className="mainForm">
          <div className="radio-group-trailer-type">
            {eventData?.data?.checkIn[0].options.map(
              (item: any, index: any) => {
                return (
                  <label key={index}>
                    <input
                      type="radio"
                      name="TimeTracking"
                      value={item.name}
                      onChange={e => onRadioBtnChange(e)}
                      defaultChecked={
                        assetReducer?.asset?.equipmentType === item.name
                      }
                    />
                    {item.name}
                  </label>
                )
              }
            )}
          </div>
        </form>
      </div>
      <BottomBar
        disabled={disabledProceedET}
        onClick={() => setKioskTrailerType()}
        text={t("continue")}
      />
    </>
  )
}

export default KioskTrailerType
